import { STRIPE_TEXT_PRIMARY } from 'constants/stripe'

export const sharedStyles = {
  sectionContainer: {
    marginTop: '16px',
  },
  sectionHeading: {
    color: '#000000',
    marginBottom: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  checkbox: {
    width: '14px',
    height: '14px',
    cursor: 'pointer',
    marginLeft: '4px',
  },
  checkboxLabel: {
    color: STRIPE_TEXT_PRIMARY,
    fontSize: '14px',
  },
  subSectionContainer: {
    marginLeft: '20px',
    marginTop: '8px',
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    color: STRIPE_TEXT_PRIMARY,
    fontSize: '14px',
  },
  radioInput: {
    width: '14px',
    height: '14px',
    cursor: 'pointer',
  },
  textInput: {
    height: '32px',
    border: '1px solid #e2e8f0',
    borderRadius: '4px',
    padding: '0 8px',
    backgroundColor: 'white',
    color: STRIPE_TEXT_PRIMARY,
    fontSize: '14px',
    outline: 'none',
  },
  removeButton: {
    background: 'none',
    border: 'none',
    color: '#e53d3d',
    cursor: 'pointer',
    padding: '4px',
    fontSize: '16px',
  },
  addButton: {
    height: '32px',
    padding: '0 12px',
    backgroundColor: '#6772e5',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
}
